module.exports = __webpack_public_path__ + "static/media/bluecity.ff8b0ed7.jpg";